/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/event?action=TEMPLATE&tmeid=NWVuc2FkZTNoODVwaTc1dXVjNTl2cW1hNTEgZmFpc2FsaWJyYWhpbW51cmZhbmlAbQ&tmsrc=faisalibrahimnurfani%40gmail.com`;
export const GOOGLE_MAPS_LINK = `https://goo.gl/maps/VsCMTxupsujLztgq6`;

/**
 * Wedding time 1657324939 1657324939
 */
export const EPOCH_START_EVENT = 1657245739;
export const EPOCH_END_EVENT = 1657245739;
export const UTC_WEDDING_TIME = '2022-07-08 09:00:00';
